export const ChatThinkingIndicator = () => (
  <div className="flex items-center gap-1 py-2">
    <div className="flex gap-1">
      <div className="size-2 bg-muted-foreground/60 rounded-full animate-bounce [animation-delay:-0.3s]" />
      <div className="size-2 bg-muted-foreground/60 rounded-full animate-bounce [animation-delay:-0.15s]" />
      <div className="size-2 bg-muted-foreground/60 rounded-full animate-bounce" />
    </div>
  </div>
);
